import { Component, Input } from '@angular/core';

import { RadioOptionsComponent } from '../controls/radio.options.component';

@Component({
  selector: 'app-active-test-html',
  templateUrl: './active.test.html',
  providers: [],
  styleUrls: ['../new.application.style.scss', './active.test.style.scss']
})
export class ActiveTestHtmlComponent extends RadioOptionsComponent {
  constructor() {
    super();
    this.key = 'run-active-tests';
    this.radioOptions.push({
      label: 'Yes',
      internalValue: true,
      selected: false,
      disabled: true
    });
    this.radioOptions.push({
      label: 'No',
      internalValue: false,
      selected: true,
      disabled: false
    });
  }
}
